export enum LegalizationAlertStatusEnum {
    NoAlert = 1,
    ValidDocument = 2,
    ApproachingExpiration = 3,
    ExpirationDateReached = 4,
    AlertDeactivated = 5,
    ActionsTaken = 6,
    ActionsTakenApproachingExpiration = 7,
    ActionsTakenExpirationDateReached = 8
}
